import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingCompletionComponent } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion/fi-onboarding-completion.component';
import { FiOnboardingCompletionContainerComponent } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion-container/fi-onboarding-completion-container.component';
import { FiOnboardingCompletionService } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { MatCardModule } from '@angular/material/card';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiOnboardingProgressBarModule } from '../fi-onboarding-progress-bar/fi-onboarding-progress-bar.module';
import { FiOnboardingSectionCompletionComponent } from './fi-onboarding-section-completion/fi-onboarding-section-completion.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FiCircularGradientProgressBarModule } from '@fi-shared/fi-circular-gradient-progress-bar/fi-circular-gradient-progress-bar.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FiGradientTimerModule } from '@fi-app/shared/fi-gradient-timer/fi-gradient-timer.module';
import { FiGradientCircleModule } from '@fi-shared/fi-gradient-circle/fi-gradient-circle.module';
import { FiCompletionStepComponent } from './fi-onboarding-section-completion/completion-step/completion-step.component';
import { FiProgressTimelineModule } from '@fi-shared/fi-progress-timeline/fi-progress-timeline.module';
import { FiOnboardingCompletionActionsBuilderService } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion-actions-builder.service';
import { FiOnboardingStepCompletionDialogComponent } from './fi-onboarding-step-completion-dialog/fi-onboarding-step-completion-dialog.component';
import { FiOnboardingCompletionHelperService } from './fi-onboarding-completion-helper.service';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { DocumentLayoutViewModule } from '@fi-app/document/layout/document-layout-view.module';
import { FiInfoBannerModule } from '@fi-app/shared/fi-info-banner/fi-info-banner.module';
import { MediaBankPreviewModule } from '@fi-app/media-bank/media-bank-preview/media-bank-preview.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { FiOnboardingStepCompletionComponent } from './fi-onboarding-step-completion/fi-onboarding-step-completion.component';
import { FiDocumentCompletionComponent } from './fi-onboarding-step-completion/document-completion/document-completion.component';
import { FiMediaBankCompletionComponent } from './fi-onboarding-step-completion/mediabank-completion/mediabank-completion.component';
import { FiTodoListCompletionComponent } from './fi-onboarding-step-completion/todo-list-completion/todo-list-completion.component';
import { FiQuizCompletionComponent } from './fi-onboarding-step-completion/quiz-completion/quiz-completion.component';
import { FiTodoListCompletionSectionComponent } from './fi-onboarding-step-completion/todo-list-completion/todo-list-completion-section/todo-list-completion-section.component';
import { FiTodoListProgressComponent } from './fi-onboarding-step-completion/todo-list-completion/todo-list-progress/todo-list-progress.component';
import { FiTodoListItemComponent } from './fi-onboarding-step-completion/todo-list-completion/todo-list-completion-section/todo-list-item/todo-list-item.component';
import { FiQuizStartInfoComponent } from './fi-onboarding-step-completion/quiz-completion/quiz-start-info/quiz-start-info.component';
import { FiQuizInProgressComponent } from './fi-onboarding-step-completion/quiz-completion/quiz-in-progress/quiz-in-progress.component';
import { FiQuizProgressCurrentQuestionComponent } from './fi-onboarding-step-completion/quiz-completion/quiz-in-progress/quiz-progress-current-question/quiz-progress-current-question.component';
import { FiQuizProgressStepperComponent } from './fi-onboarding-step-completion/quiz-completion/quiz-in-progress/quiz-progress-stepper/quiz-progress-stepper.component';
import { FiQuizCompletedComponent } from './fi-onboarding-step-completion/quiz-completion/fi-quiz-completed/fi-quiz-completed.component';
import { FiOnboardingCompletionSyncService } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion-sync.service';
import { FiOnboardingSynchronizedModule } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized.module';
import { FiOnboardingSynchronizedAssigneesListComponent } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-synchronized-assignees-list/fi-onboarding-synchronized-assignees-list.component';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiOnboardingCompletionShortInfoComponent } from './fi-onboarding-completion-short-info/fi-onboarding-completion-short-info.component';
import { MatRadioModule } from '@angular/material/radio';
import { FiExpandableTextDirectiveModule } from '../../shared/fi-expandable-text-directive/fi-expandable-text-directive.module';
import { FiTodoListSectionItemModule } from '../fi-todo/fi-todo-list-section-item/fi-todo-list-section-item.module';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiMatIconCheckboxMenuModule,
        MatCardModule,
        FiBindHtmlCompileModule,
        FiAttachmentsModule,
        FiOnboardingProgressBarModule,
        MatExpansionModule,
        FiCircularGradientProgressBarModule,
        MatProgressSpinnerModule,
        FiGradientTimerModule,
        FiGradientCircleModule,
        FiProgressTimelineModule,
        FiLoadingModule,
        DocumentLayoutViewModule,
        FiInfoBannerModule,
        MediaBankPreviewModule,
        MatCheckboxModule,
        MatRadioModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        FiIconTooltipButtonModule,
        MatTabsModule,
        FiDirectivesModule,
        FiOnboardingSynchronizedModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        FiInfoBannerModule,
        FiExpandableTextDirectiveModule,
        FiTodoListSectionItemModule,
    ],
    declarations: [
        FiOnboardingCompletionComponent,
        FiOnboardingSynchronizedAssigneesListComponent,
        FiOnboardingCompletionContainerComponent,
        FiOnboardingSectionCompletionComponent,
        FiCompletionStepComponent,
        FiOnboardingStepCompletionDialogComponent,
        FiDocumentCompletionComponent,
        FiMediaBankCompletionComponent,
        FiTodoListCompletionComponent,
        FiQuizCompletionComponent,
        FiTodoListCompletionSectionComponent,
        FiTodoListProgressComponent,
        FiTodoListItemComponent,
        FiQuizStartInfoComponent,
        FiQuizInProgressComponent,
        FiQuizProgressCurrentQuestionComponent,
        FiQuizProgressStepperComponent,
        FiQuizCompletedComponent,
        FiOnboardingStepCompletionComponent,
        FiOnboardingCompletionShortInfoComponent,
    ],
    providers: [
        FiOnboardingCompletionService,
        FiOnboardingCompletionActionsBuilderService,
        FiOnboardingCompletionHelperService,
        FiOnboardingCompletionSyncService,
    ],
    exports: [
        FiOnboardingCompletionComponent,
        FiOnboardingStepCompletionComponent,
        FiOnboardingCompletionContainerComponent,
        FiOnboardingCompletionShortInfoComponent,
    ],
})
export class FiOnboardingCompletionModule {}
